import TableWidgetCellStyle from './TableWidgetCellStyle'

export default class TableWidgetCell {
    constructor() {
        this.style = new TableWidgetCellStyle()
        this.term = ''
        this.disabled = false
        this.headRowIndex = null
        this.headColIndex = null
        this.term_image = ''
    }
}
